<template>
    <div id="header-right" class="header-left-side">
        <!-- <md-button
            v-tippy="{
                followCursor: true,
                placement: 'bottom-end',
                theme: isDarkMode ? 'light-border' : 'google',
            }"
            :content="isDarkMode ? $t('message.nightModeOn') : $t('message.nightModeOff')"
            class="custom-button header-btn"
            @click="toggleDarkMode"
        >
            <md-icon :style="{ color: darkMode ? 'yellow' : 'black' }">wb_incandescent</md-icon>
        </md-button>-->
        <!--<div v-if="!isAdmin && settings.privateChatEnabled" style="position: relative">
            <md-button class="custom-button" data-v-step="3" @click="toggleChat()">
                <Chats />
            </md-button>
        </div>-->
        <SupsisButton ghost @click="() => (debugToolVisible = true)" v-if="debugMode"> Debug Mode</SupsisButton>
        <!-- Post-it Tahtası Toggle Butonu -->
        <md-button
            v-if="!blockedConnection && isPostitEnabled"
            @click="togglePostitBoard"
            style="min-width: fit-content; cursor: pointer; display: flex"
            v-tippy="{
                placement: 'bottom',
                theme: isDarkMode ? 'light-border' : 'google',
            }"
            :content="$store.state.app.postitBoardVisible ? 'Not Tahtasını Kapat' : 'Not Tahtasını Aç'"
        >
            <md-icon :style="{ color: darkMode ? 'yellow' : 'black' }">
                {{ $store.state.app.postitBoardVisible ? 'close' : 'sticky_note_2' }}
            </md-icon>
        </md-button>

        <div
            v-if="!blockedConnection"
            id="email-icon-header"
            class="header-email-button"
            @click="() => this.$router.replace(`/mails?selected=My`)"
        >
            <component v-bind:is="'MailIcon'" class="myIcon" />
            <span class="email-badge" v-if="allUnreadMailCounts !== 0">
                {{ allUnreadMailCounts > 99 ? '99+' : allUnreadMailCounts }}
            </span>
        </div>

        <div
            v-if="!blockedConnection"
            class="header-contact-button"
            @click.stop="handleContactUsClick"
        >
            <component v-bind:is="'ChatIcon'" class="myIcon" />
            <span class="contact-text">{{ $t('message.contactUs') }}</span>
        </div>

        <md-button
            id="supsis-copilot"
            class="custom-button header-btn btnCopilot"
            @click="$feature.beforeUseChatCopilot(activateCopilot)"
            v-if="CONFIG.FEATURES.HEYSUPSIS_ENABLED && isTicketPage()"
        >
            <img src="/static/img/copilot.png" />
        </md-button>

        <TodayEvent v-if="!blockedConnection" />
        <!-- Show Intro Start-->
        <a-popover
            v-if="!blockedConnection"
            id="popoverHelpMenu"
            v-model="popovers.isHelpMenuPopoverOpen"
            data-v-step="4"
            placement="bottomRight"
            trigger="click"
            overlayClassName="help-menu-popover"
        >
            <template slot="content">
                <div id="popoverHelpMenuOpened" class="popover-menu-container">
                    <div class="menu-item" @click="toggleKeyboardShotcutModal(true)">
                        <span class="menu-icon" style="color: #4a6cf7">
                            <i class="material-icons">keyboard</i>
                        </span>
                        <span class="menu-text">{{ $t("message.keyboardShortcuts") }}</span>
                    </div>

                    <div class="menu-item" @click="showModal">
                        <span class="menu-icon" style="color: #3498db">
                            <i class="material-icons">description</i>
                        </span>
                        <span class="menu-text">{{ $t("message.supsisDocument") }}</span>
                    </div>

                    <div class="menu-item" @click="openNewsModal">
                        <span class="menu-icon" style="color: #ff6b35">
                            <i class="material-icons">new_releases</i>
                        </span>
                        <span class="menu-text">{{ $t("message.news") }}</span>
                    </div>

                    <div class="menu-item" @click="integrationInstruction">
                        <span class="menu-icon" style="color: #f64e60">
                            <i class="material-icons">support</i>
                        </span>
                        <span class="menu-text">{{ $t("message.notIntegrated") }}</span>
                    </div>

                    <div class="menu-item" @click="connectSupportTeamRequest">
                        <span class="menu-icon" style="color: #27ae60">
                            <i class="material-icons">help_center</i>
                        </span>
                        <span class="menu-text">{{ $t("message.supportUs") }}</span>
                    </div>

                    <div class="menu-item" @click="makeBugReport">
                        <span class="menu-icon" style="color: #e74c3c">
                            <i class="material-icons">report</i>
                        </span>
                        <span class="menu-text">{{ $t("message.reportBug") }}</span>
                    </div>

                    <div class="menu-item" @click="$router.push('/supsis-app')">
                        <span class="menu-icon" style="color: #9b59b6">
                            <i class="material-icons">apps</i>
                        </span>
                        <span class="menu-text">{{ $t("message.getApps") }}</span>
                    </div>

                    <div class="menu-item" @click="openWebChat()">
                        <span class="menu-icon" style="color: #1abc9c">
                            <i class="material-icons">preview</i>
                        </span>
                        <span class="menu-text">{{ $t("message.visitorScreen") }}</span>
                    </div>

                    <div class="menu-item" @click="openIDFinder">
                        <span class="menu-icon" style="color: #f1c40f">
                            <i class="material-icons">find_in_page</i>
                        </span>
                        <span class="menu-text">ID Finder</span>
                    </div>

                    <div class="menu-item" @click="openQRGenerator">
                        <span class="menu-icon" style="color: #9c27b0">
                            <i class="material-icons">qr_code</i>
                        </span>
                        <span class="menu-text">QR Generator</span>
                    </div>

                    <div class="menu-item" @click="openWABAPricingTool">
                        <span class="menu-icon" style="color: #25d366">
                            <i class="material-icons">calculate</i>
                        </span>
                        <span class="menu-text">WABA Pricing Tool</span>
                    </div>

                    <div class="menu-item" @click="openWebhookTool">
                        <span class="menu-icon" style="color: #ff9800">
                            <i class="material-icons">webhook</i>
                        </span>
                        <span class="menu-text">Webhook Tool</span>
                    </div>

                    <div class="menu-item" @click="openWhatsappComparison">
                        <span class="menu-icon" style="color: #25d366">
                            <i class="material-icons">compare</i>
                        </span>
                        <span class="menu-text">WhatsApp Solutions Comparison</span>
                    </div>

                    <div class="menu-divider"></div>

                    <div class="menu-item version-item">
                        <span class="menu-icon" style="color: #2ecc71">
                            <i class="material-icons">done</i>
                        </span>
                        <span class="menu-text">SUPSIS {{ version.versionStr }}</span>
                    </div>

                    <AnnouncementNotifications />
                </div>
            </template>

            <div class="header-info-button" :class="{ infoLight: unreadAnnouncements }">
                <a-badge color="#F64E60" v-if="unreadAnnouncements">
                    <component v-bind:is="'InfoIcon'" class="myIcon" />
                </a-badge>
                <component v-bind:is="'InfoIcon'" class="myIcon" v-else />
            </div>
        </a-popover>
        <div id="notifications">
            <a-popover
                v-if="!blockedConnection"
                v-model="popovers.notifications"
                placement="bottomRight"
                trigger="click"
                :overlayClassName="'no-padding notification-popover'"
            >
                <template slot="content">
                    <NotificationPanel v-if="popovers.notifications" />
                </template>

                <div class="header-notification-button">
                    <component v-bind:is="'NotificationIcon'" class="myIcon" />
                    <span class="notification-badge" v-if="unreadNotificationCount !== 0">
                        {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
                    </span>
                </div>
            </a-popover>
        </div>
        <div class="header-selection-item">
            <b-dropdown v-if="adminUser" id="user-dropdown" :text="adminUser.email" class="h-100" right>
                <template slot="button-content">
                    <img alt="Kullanıcı resmi" class="rounded-circle mx-1" src="https://placeimg.com/30/30/people" />
                    <small>{{ adminUser.name }}</small>
                </template>
                <b-dropdown-item class="mt-2" @click.prevent="logout">
                    <font-awesome-icon class="mr-2" icon="sign-out-alt" />
                    {{ $t("message.logout") }}
                </b-dropdown-item>
            </b-dropdown>
            <a-modal
                id="conversation-color-help2"
                :footer="null"
                :title="$t('message.chatColorMeanings')"
                :visible="chatColorModalVisible"
                @cancel="toggleChatColorModal(false)"
                @ok="toggleChatColorModal(false)"
            >
                <ConversationColorHelp />
            </a-modal>
            <a-modal
                id="ShortcutModal"
                :footer="null"
                :title="$t('message.keyboardShortcuts')"
                :visible="keyboardShortCutsModalVisible"
                @cancel="toggleKeyboardShotcutModal(false)"
            >
                <KeyboardShortcuts />
            </a-modal>
        </div>
        <a-modal v-model="debugToolVisible" title="Debug Tool" class="debug-tool-modal-wrapper" :footer="null">
            <DebugTool />
        </a-modal>
        <a-modal
            :visible.sync="visible"
            :cancel-text="null"
            @ok="handleOk"
            :width="1150"
            :footer="false"
            :footer-hide="true"
            class="custom-modal"
            v-on:cancel="visible = false"
        >
            <div style="height: 700px">
                <iframe style="width: 100%; height: 100%; border: none" src="https://doc.supsis.live/"></iframe>
            </div>
        </a-modal>
        <a-modal
            :visible.sync="qrGeneratorModalVisible"
            :cancel-text="null"
            @ok="() => (qrGeneratorModalVisible = false)"
            :width="1200"
            :footer="false"
            :footer-hide="true"
            class="custom-modal qr-generator-modal"
            v-on:cancel="qrGeneratorModalVisible = false"
            title="QR Generator"
        >
            <div style="height: 700px">
                <iframe
                    style="width: 100%; height: 100%; border: none"
                    src="https://qr.supsis.ai"
                    allow="camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation"
                ></iframe>
            </div>
        </a-modal>
        <a-modal
            :visible.sync="wabaPricingModalVisible"
            :cancel-text="null"
            @ok="() => (wabaPricingModalVisible = false)"
            :width="1200"
            :footer="false"
            :footer-hide="true"
            class="custom-modal waba-pricing-modal"
            v-on:cancel="wabaPricingModalVisible = false"
            title="WABA Pricing Tool"
        >
            <div style="height: 85vh">
                <iframe
                    style="width: 100%; height: 100%; border: none"
                    src="https://wabapricing.supsis.ai"
                    allow="camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation"
                ></iframe>
            </div>
        </a-modal>
        <a-modal
            :visible.sync="whatsappComparisonModalVisible"
            :cancel-text="null"
            @ok="() => (whatsappComparisonModalVisible = false)"
            :width="1400"
            :footer="false"
            :footer-hide="true"
            class="custom-modal whatsapp-comparison-modal"
            v-on:cancel="whatsappComparisonModalVisible = false"
            title="WhatsApp Solutions Comparison"
        >
            <WhatsappComparison />
        </a-modal>
        <NewsModal ref="newsModal" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCheckCircle,
    faClock,
    faMinusCircle,
    faPowerOff,
    faSignOutAlt,
    faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import SYSTEM_PUBSUB, { publishMessage, SystemMessageTypes } from "../utils/systemPubSub";
import { log2 } from "../utils/log2";
import moment from "moment";
import { sendSocketMessage } from "../utils/socketStream";
import RepresentativeSettings from "./RepresentativeSettings";
import * as _ from "lodash";
import version from "../utils/version";
import { onNewVersionReceived } from "../utils/utils";
import Chats from "../components/svg/Chats";
import Avatar from "vue-avatar";
import ConversationColorHelp from "./ConversationColorHelp";
import KeyboardShortcuts from "./KeyboardShortcuts";
import Version from "../components/svg/Version";
import ColorMeaning from "../components/svg/ColorMeaning";
import ShowIntro from "../components/svg/ShowIntro";
import Keyboard from "../components/svg/Keyboard";
import Online from "../components/svg/Online";
import Away from "../components/svg/Away";
import Busy from "../components/svg/Busy";
import Offline from "../components/svg/Offline";
import Logout from "../components/svg/Logout";
import SocketConnect from "./svg/SocketConnect";
import CountryFlag from "vue-country-flag";
import UserName from "../components/svg/UserName";
import Vue from "vue";
import Question from "../components/svg/Question";
import Settings from "../components/svg/Settings";
import { WEB_PUSH_NOTIFICATION_SERVICE } from "../push-notification/subscribe";
import AnnouncementNotifications from "./AnnouncementNotifications";
import NewsModal from "./common/NewsModal.vue";
import NewIcon from "./svg/NewIcon.vue";
import NotificationPanel from "../views/Pages/Notification/NotificationPanel.vue";
import SupsisBadge from "./common/SupsisBadge.vue";
import TodayEvent from "../views/Pages/Calendar/Component/TodayEvent.vue";
import CONFIG from "../config/config";
import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";
import DebugTool from "./DebugTool.vue";
import WhatsappDebugTool from "../views/Pages/Whatsapp/components/WhatsappDebugTool.vue";
import WhatsappComparison from "./WhatsappComparison.vue";
import MailIcon from "./svg/header/MailIcon.vue";
import InfoIcon from "./svg/header/InfoIcon.vue";
import NotificationIcon from "./svg/header/NotificationIcon.vue";
import CalendarIcon from "./svg/appSwitcherIcon/CalendarIcon.vue";
import ChatIcon from "./svg/header/ChatIcon.vue";

library.add(faCheckCircle, faClock, faMinusCircle, faPowerOff, faUserCog, faSignOutAlt);
const log = log2("HeaderRight");
Vue.component("country-flag", CountryFlag);

export default {
    name: "HeaderRight",
    components: {
        WhatsappDebugTool,
        TodayEvent,
        NotificationPanel,
        NewIcon,
        AnnouncementNotifications,
        RepresentativeSettings,
        Avatar,
        KeyboardShortcuts,
        Chats,
        ConversationColorHelp,
        Question,
        Settings,
        Version,
        ShowIntro,
        Keyboard,
        Online,
        Away,
        Busy,
        Offline,
        UserName,
        Logout,
        SocketConnect,
        ColorMeaning,
        NewsModal,
        SupsisBadge,
        SupsisButton,
        DebugTool,
        WhatsappComparison,
        MailIcon,
        InfoIcon,
        NotificationIcon,
        CalendarIcon,
        ChatIcon
    },
    data() {
        return {
            gravatar: null,
            visible: false,
            renderCount: 0,
            chatColorModalVisible: false,
            keyboardShortCutsModalVisible: false,
            zoomMaxRangeBound: 125,
            zoomMinRangeBound: 75,
            zoomValue: 100,
            modalVisible: false,
            version,
            newVersionAvailable: false,
            volume: -1,
            isOpenLang: false,
            isLiveSupportActive: false,
            customerDomainsFetched: false,
            isVisibleRepresentativeModalInSetting: true,
            isVisibleRepresentativeModalInExitMenu: true,
            CONFIG,
            debugToolVisible: false,
            qrGeneratorModalVisible: false,
            wabaPricingModalVisible: false,
            webhookToolModalVisible: false,
            whatsappComparisonModalVisible: false,
        };
    },
    computed: {
        ...mapState({
            blockedConnection: (state) => state.app.blockedConnection,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => state.auth.adminUser != null,
            menu: (state) => state.layout.menu,
            shortcutReminder: (state) => state.app.shortcutReminder,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            language: (state) => state.language.language,
            zoom: (state) => state.layout.zoom,
            settings: (state) => state.setting.settings,
            fakeMode: (state) => state.app.fakeMode,
            socketConnected: (state) => state.socketStatus.socket_connected,
            offlineMode: (state) => state.setting.offlineMode,
            debugMode: (state) => state.app.debugMode,
            socket: (state) => state.socketStatus.current_socket,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            customerDomains: (state) => state.visitor.customerDomains,
            popovers: (state) => state.app.headerPopoverStatus,
            announcements: (state) => state.announcement.announcements,
            unreadNotificationCount: (state) => state.app.unreadNotificationCount,
            allUnreadMailCounts: (state) => state.mail.allUnreadMailCounts,
            isPostitEnabled: (state) => localStorage.getItem("postit") === "true",
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            unreadAnnouncements: "announcement/unreadAnnouncements",
        }),
        darkMode: {
            set(value) {
                this.updateDarkMode(value);
            },
            get() {
                return this.isDarkMode;
            },
        },
        shortcutReminderEnabled: {
            set(value) {
                this.setShortcutReminder(value);
            },
            get() {
                return this.shortcutReminder;
            },
        },
    },
    methods: {
        copySite() {
            navigator.clipboard
                .writeText(this.site._id)
                .then(() => {
                    this.$message.success("Site ID Kopyalandı");
                })
                .catch((err) => {
                    this.$message.success("Site ID  Kopyalanamadı");
                });
        },
        openWebChat() {
            window.open(this.visitorScreenUrl, "_blank");
        },
        isTicketPage() {
            return this.$route?.path?.includes("ticket") || false;
        },
        showModal() {
            this.visible = true;
            this.popovers.isSettingPopoverOpen = false;
            this.popovers.isHelpMenuPopoverOpen = false;
        },
        handleOk(e) {
            this.visible = false;
        },
        ...mapActions({
            setUserStatus: "auth/setStatus",
            doLogout: "auth/logout",
            setLanguage: "language/setLanguage",
            changeZoom: "layout/changeZoom",
            refreshAuthUser: "auth/refreshAuthUser",
            getUsers: "user/getUsers",
            getUser: "user/getUser",
            updateUser: "user/updateUser",
            updateDarkMode: "user/updateDarkMode",
            togglePrivateChatVisibleState: "app/togglePrivateChatVisibleState",
            setChatFakeMode: "app/setChatFakeMode",
            getCustomerDomains: "visitor/getCustomerDomains",
            setShortcutReminder: "app/setShortcutReminder",
            getLastAnnouncements: "announcement/getLastAnnouncements",
            setNotificationsStatus: "app/setNotificationsStatus",
            addNewWindow: "app/addNewWindow",
        }),
        makeBugReport() {
            const capture = async () => {
                const canvas = document.createElement("canvas");
                try {
                    const stream = await navigator.mediaDevices.getDisplayMedia({
                        video: { mediaSource: "screen" },
                    });
                    // get correct video track
                    const track = stream.getVideoTracks()[0];
                    const imageCapture = new ImageCapture(track);
                    // take first frame only
                    setTimeout(async () => {
                        const bitmap = await imageCapture.grabFrame();
                        track.stop();
                        canvas.width = bitmap.width;
                        canvas.height = bitmap.height;
                        const context = canvas.getContext("2d");
                        context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
                        this.errorFileURl = canvas.toDataURL();
                        this.errorModalVisible = true;
                    }, 1000);
                } catch (err) {
                    console.error("Error: " + err);
                }
            };
            capture();
        },
        activateCopilot() {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.ACTIVE_VOICE_ASSISTANT, {});
        },
        updateVolume: _.debounce(async function (volume, showNotification = true) {
            log.debug("update volume called", this);
            this.user.audioAlertVolume = volume / 100;
            await this.updateUser({ ...this.user });
            await this.refreshAuthUser();
            if (showNotification)
                this.$toasted.show(this.$t("message.userVolumeUpdated"), {
                    duration: 3000,
                    position: "bottom-center",
                });
        }, 1000),
        updateZoom: _.debounce(function (value) {
            this.changeZoom(value);
        }, 1000),
        disconnectSocket() {
            if (this.debugMode && this.socketConnected) {
                this.socket.disconnect();
            }
        },
        toggleDarkMode() {
            this.updateDarkMode(!this.darkMode);
        },
        setModalVisible(modalVisible, option) {
            this.isVisibleRepresentativeModalInSetting = "InSetting" === option;
            this.isVisibleRepresentativeModalInExitMenu = "InExitMenu" === option;
            this.popovers.isRepresentativeSettingsPopoverOpen = modalVisible;
            this.modalVisible = modalVisible;
        },
        showIntro() {
            this.setChatFakeMode(true);
            setTimeout(() => {
                document.getElementById("contents").style.pointerEvents = "none";
                document.getElementById("sidebar").style.pointerEvents = "none";
            }, 100);
            publishMessage("showIntro", {});
        },
        toggleChatColorModal(visible) {
            log.debug("toggleChatColorModal called", visible);
            this.chatColorModalVisible = visible;
        },
        toggleKeyboardShotcutModal(visible) {
            log.debug("toggleKeyboardShotcutModal called", visible);
            this.keyboardShortCutsModalVisible = visible;
        },
        setCurrentLanguage(languageCode) {
            log.info("setCurrentLanguage", languageCode);
            this.setLanguage(languageCode);
            this.$i18n.locale = this.language.code;
            if (moment.locale() !== languageCode) moment.locale(languageCode);
            this.isOpenLang = !this.isOpenLang;
        },
        setStatus(status) {
            sendSocketMessage("user status-change", {
                userId: this.user._id,
                status: status,
                siteId: this.site._id,
            });

            this.setUserStatus(status);
        },
        integrationInstruction() {
            log("integrationInstruction", this.$router);
            this.$router.push("/install-code");
            const elem = document.getElementById("popoverHelpMenuOpened");
            if (elem && !elem.style.display) {
                document.getElementById("popoverHelpMenu").click();
            }
        },

        logout() {
            if (this.user) {
                WEB_PUSH_NOTIFICATION_SERVICE.unsubscribeFromAllTopic(this.site._id, this.user._id);
            }
            this.doLogout();
            this.$router.push("/login");
        },
        openPDF() {
            let pdfPath = "https://drive.google.com/file/d/1jLKdOUT_Y40zviEjsNw2oeuiNH4tz3i7/view";
            window.open(pdfPath, "_blank", "fullscreen=yes");
        },
        nameSorter(text) {
            if (text.length > 11) text = text.slice(0, 11) + "..";
            return text;
        },
        isSiteIntegrated() {
            return this.customerDomainsFetched && this.customerDomains.length;
        },
        reloadPage() {
            window.location.reload();
        },
        connectSupportTeamRequest() {
            log("connectSupportTeamRequest");
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {});
        },
        connectSupportTeamDirect() {
            // Direkt canlı destek bağlantısı - popover açılmasını engellemek için
            log("connectSupportTeamDirect - Direct support connection");
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {});
        },
        openNewsModal() {
            this.$refs.newsModal.visible = true;
        },
        openIDFinder() {
            this.addNewWindow({
                type: "id-finder",
                title: "ID Finder",
                description: "Sistem ID'lerini bulmak ve kopyalamak için kullanabilirsiniz",
                size: "large",
                autoClose: false,
                multiple: false,
                footer: false,
                payload: {},
            });
            // Menüyü kapat
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
        },
        openQRGenerator() {
            this.qrGeneratorModalVisible = true;
            // Menüyü kapat
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
        },
        openWABAPricingTool() {
            this.wabaPricingModalVisible = true;
            // Menüyü kapat
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
        },
        openWebhookTool() {
            window.open("https://hook.supsis.ai", "_blank");
            // Menüyü kapat
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
        },
        togglePostitBoard() {
            this.$store.commit('app/SET_POSTIT_BOARD_VISIBLE', !this.$store.state.app.postitBoardVisible);
        },
        openWhatsappComparison() {
            this.whatsappComparisonModalVisible = true;
            // Menüyü kapat
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
        },
        handleContactUsClick() {
            // Direkt canlı destek bağlantısı - popover açmadan
            this.connectSupportTeamDirect();
        },
    },
    mounted() {
        log("mounted zoom", this.zoom);
        this.zoomValue = this.zoom;
        /* this.darkMode.isActive = this.isDarkMode*/
        document.body.style.zoom = this.zoom + "%";
        this.$forceUpdate();
        //Get new version information If ther is new version ask to reload with button
        onNewVersionReceived.then((x) => {
            this.newVersionAvailable = true;
        });
        this.getCustomerDomains().then((x) => {
            this.customerDomainsFetched = true;
        });
        this.getLastAnnouncements({});
    },
    beforeDestroy() {},
    watch: {
        zoom(newValue) {
            log("zoom value changed", newValue);
            document.body.style.zoom = newValue + "%";
            this.$forceUpdate();
        },
        zoomValue(newValue, oldValue) {
            this.updateZoom(newValue);
        },
        volume(newValue, oldValue) {
            log.debug("volume change", { newValue, oldValue });
            if (newValue !== oldValue && oldValue !== -1) this.updateVolume(newValue, oldValue >= 0);
        },
        user(newUser) {
            log.debug("newUser", newUser);
            this.volume = newUser.audioAlertVolume ? newUser.audioAlertVolume * 100 : 0;
        },
        "popovers.isSettingPopoverOpen": function (newValue) {
            if (!newValue) {
                this.isOpenLang = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.header-right-general-settings {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 5px;
}

#header-right {
    .switch-input {
        &.dark-mode {
            .material-icons {
                font-size: 16px;
            }
        }
    }

    .header-email-button,
    .header-info-button,
    .header-notification-button,
    .header-contact-button {
        position: relative !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 32px !important;
        height: 32px !important;
        min-width: 32px !important;
        border-radius: 10px !important;
        cursor: pointer !important;
        border: 1px solid #e4e6ef !important;
        outline: none !important;
        padding: 0 !important;
        margin: 0 6px !important;
        box-sizing: border-box !important;
        user-select: none !important;

        &:hover {
            background-color: #f8f9fb !important;
            border-color: #d1d5db !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
        }

        &:active {
            transform: translateY(0px) !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
            background-color: #f3f4f6 !important;
        }

        .myIcon {
            width: 16px !important;
            height: 16px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            transition: all 0.2s ease !important;
        }

        &:hover .myIcon {
            transform: scale(1.05) !important;
        }
    }

    .header-info-button.infoLight {
        //background-color: #fff7ed !important;
        //border-color: #fb923c !important;

        &:hover {
            //background-color: #fed7aa !important;
            //border-color: #f97316 !important;
        }
    }

    .header-email-button,
    .header-notification-button,
    .header-contact-button {
        width: auto !important;
        min-width: 32px !important;
        padding: 0 10px !important;
        gap: 6px !important;

        .email-badge,
        .notification-badge {
            position: relative !important;
            min-width: 18px !important;
            height: 18px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: linear-gradient(135deg, #ef6961 0%, #e8584f 100%) !important;
            color: white !important;
            border-radius: 9px !important;
            font-size: 9px !important;
            font-weight: 600 !important;
            padding: 0 5px !important;
            line-height: 1 !important;
            letter-spacing: -0.3px !important;
            box-sizing: border-box !important;
        }

        .contact-text {
            font-size: 12px !important;
            font-weight: 500 !important;
            color: #8796af !important;
            white-space: nowrap !important;
            line-height: 1 !important;
        }
    }
}
</style>
<style lang="scss">
.qr-generator-modal {
    .ant-modal-body {
        padding: 0px !important;
    }
}

.waba-pricing-modal {
    .ant-modal-body {
        padding: 0px !important;
    }
    .ant-modal-content {
        height: 90vh !important;
    }
}

.whatsapp-comparison-modal {
    .ant-modal-body {
        padding: 0px !important;
        max-height: 80vh;
        overflow-y: auto;
    }
    .ant-modal-content {
        height: 85vh !important;
    }
}
#ShortcutModal {
    .ant-modal {
        width: 65% !important;
    }
}

.representativeSettings {
    .ant-modal-body {
        padding: 24px 5px 24px 0px;
    }
}

.notification-popover {
    .ant-popover-inner-content {
        padding: 0px !important;
    }
}
</style>
<style lang="scss" scoped>
#header {
    padding-left: 0px;
    border-bottom: 1px solid var(--color-border-default);
    height: 45px;

    .custom-button {
        width: 35px;
        min-width: 35px;
        height: 35px;
        border-radius: 8px;
        margin: 8px;
        border: 1px solid var(--color-border-default);

        &.notification {
            position: relative;

            .notification-badge {
                position: absolute;
                top: 0px;
                right: -5px;
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f64e60;
                color: white;
                border-radius: 15px;
                font-size: 10px;
            }
        }
    }

    .custom-version-btn {
        height: 35px;
        border-radius: 8px;
        margin: 8px;
        text-transform: capitalize !important;
        display: flex;
        align-items: center;
        flex-direction: row;
        color: #448aff;
        border: 1px solid var(--color-border-default);

        svg {
            display: flex;
            align-items: center;
            fill: #448aff;
            margin-right: 4px;
        }
    }

    .avatarSection {
        display: flex;
        align-items: center;

        span {
            font-family: Poppins;
            font-size: 13px;
            color: #b5b5c3;

            strong {
                font-family: Poppins;
                font-size: 13px;
                color: #7e8299;
            }
        }

        .avatar {
            border-radius: 8px;
            width: 35px;
            height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Poppins;
            font-size: 16px;
            overflow: hidden;

            &.online {
                color: #1bc5bd;
                background-color: #c9f7f5;
                border: 2px solid #1bc5bd;
            }

            &.offline {
                color: #f64e60;
                background-color: #fdbec5;
                border: 2px solid #f64e60;
            }

            &.away {
                color: #3699ff;
                background-color: #acd5ff;
                border: 2px solid #3699ff;
            }

            &.busy {
                color: #ffa829;
                background-color: #ffe6c1;
                border: 2px solid #ffa829;
            }

            img {
                border-radius: 7px;
                padding-top: 2px;
                padding-bottom: 2px;
            }

            .ant-avatar {
                background-color: transparent !important;
            }
        }
    }
}
</style>

<style>
.cursorPointer {
    cursor: pointer;
}

.cursorPointer:hover {
    font-weight: 600;
}

.popoverFont {
    font-family: Poppins;
    font-size: 14px;
    color: #181c32;
    font-weight: 300;
}
</style>

<style lang="scss" scoped>
// Yeni popover menü stili
.popover-menu-container {
    width: 260px !important;
    max-height: 600px !important;
    overflow-y: auto !important;
    padding: 6px 0 !important;
    scrollbar-width: thin !important;
    scrollbar-color: #e0e0e0 transparent !important;

    &::-webkit-scrollbar {
        width: 6px !important;
    }

    &::-webkit-scrollbar-track {
        background: transparent !important;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #e0e0e0 !important;
        border-radius: 3px !important;

        &:hover {
            background-color: #d0d0d0 !important;
        }
    }

    .menu-item {
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
        padding: 8px 12px !important;
        cursor: pointer !important;
        transition: all 0.15s ease !important;
        border-radius: 4px !important;
        margin: 2px 6px !important;
        background-color: transparent !important;

        &:hover {
            background-color: #f5f7fa !important;
        }

        &:active {
            transform: scale(0.98) !important;
        }

        &.version-item {
            background-color: #f8f9fa !important;
            color: #6b7280 !important;
            cursor: default !important;
            margin-top: 4px !important;
            padding: 8px 12px !important;

            &:hover {
                background-color: #f8f9fa !important;
            }

            &:active {
                transform: none !important;
            }

            .menu-text {
                color: #6b7280 !important;
            }
        }

        .menu-icon {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 20px !important;
            height: 20px !important;
            flex-shrink: 0 !important;

            .material-icons {
                font-size: 18px !important;
                line-height: 1 !important;
            }
        }

        .menu-text {
            font-size: 13px !important;
            font-weight: 500 !important;
            color: #22272d !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            flex: 1 !important;
            line-height: 1.4 !important;
        }
    }

    .menu-divider {
        height: 1px !important;
        background-color: #e5e7eb !important;
        margin: 6px 12px !important;
    }
}
</style>

<style lang="scss">
.ant-popover.help-menu-popover {
    .ant-popover-inner {
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06) !important;
        border: 1px solid #e5e7eb !important;
        padding: 0 !important;
    }

    .ant-popover-inner-content {
        padding: 0 !important;
    }

    .ant-popover-arrow {
        border-color: #e5e7eb !important;
    }
}
</style>
